import { render, staticRenderFns } from "./econsent-details.vue?vue&type=template&id=a9b5481c&scoped=true&"
import script from "./econsent-details.vue?vue&type=script&lang=js&"
export * from "./econsent-details.vue?vue&type=script&lang=js&"
import style0 from "./econsent-details.vue?vue&type=style&index=0&id=a9b5481c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9b5481c",
  null
  
)

component.options.__file = "econsent-details.vue"
export default component.exports